import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '../../components/Tabs';
import SupplierBasicInformationContainer from './SupplierBasicInformationContainer';
import SupplierContactsContainer from './SupplierContactsContainer';
import './styles.scss';

export default function SupplierDetail(props) {
  if (!props.isOpen) {
    return (<div />);
  }
  const basic = {
    tabTitle: 'Basic Information',
    renderTabContent: () => {
      return (
        <SupplierBasicInformationContainer
          closeSupplierModal={props.closeSupplierModal}
        />
      );
    },
  };
  const contacts = {
    tabTitle: 'Contacts',
    renderTabContent: () => {
      return (
        <SupplierContactsContainer />
      );
    },
  };
  const tabs = props.isNewSupplier ? [basic] : [basic, contacts];

  return (
    <section className="supplier-detail">
      <header className="supplier-detail__header">
        <p className="supplier-detail__eyebrow">
          {props.isNewSupplier ? 'Add supplier' : 'Supplier profile'}
        </p>
        <h2 className="supplier-detail__title">{props.title}</h2>
      </header>
      <Tabs
        tabs={tabs}
      />
    </section>
  );
}

const { string, bool, func } = PropTypes;

SupplierDetail.propTypes = {
  title: string.isRequired,
  isNewSupplier: bool.isRequired,
  isOpen: bool.isRequired,
  closeSupplierModal: func.isRequired,
};
